var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81818 22.229L28.1805 22.2222L28.1818 6.94394L15.5053 6.94444C14.5546 6.94444 13.6679 6.47193 13.1473 5.6878L11.2727 2.78457L2.81134 2.77778L2.81818 22.229ZM0 2.77096C0 1.2406 1.26801 0 2.81134 0H11.3268C12.1066 0 13.0835 0.519287 13.5094 1.16065L15.5053 4.16667H28.1761C29.7357 4.16667 31 5.4075 31 6.94394V22.2227C31 23.7566 29.7367 25 28.1805 25H2.81946C1.26231 25 0 23.7602 0 22.229V2.77096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuList);
export default __webpack_public_path__ + "static/media/menu-list.40999b821a6c583c994dcb208948f196.svg";
export { ForwardRef as ReactComponent };